var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('page-title',{attrs:{"title":_vm.providerName}}),_c('div',[_c('provider-info-readonly',{on:{"setFormKey":_vm.setFormKey}})],1),_c('div',[(
          _vm.status ==
          this.$providerStoreCooperation.STORE_RELATIONSHIP_STATUS_REQUEST
        )?_c('v-row',[_c('v-col')],1):_vm._e(),(
          _vm.status ==
          this.$providerStoreCooperation.STORE_RELATIONSHIP_STATUS_COOPERATION
        )?_c('v-row',[_c('v-col',{attrs:{"cols":"6"}}),_c('v-col',{attrs:{"cols":"6"}},[_c('updateCooperation',{attrs:{"type":"cancel","providerId":_vm.providerId,"storeId":_vm.storeId,"name":_vm.providerName,"role":"store","routeName":"store-cooperation-cancel"}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }